import { render, staticRenderFns } from "./VoteGoods.vue?vue&type=template&id=08285824&scoped=true&"
import script from "./VoteGoods.vue?vue&type=script&lang=js&"
export * from "./VoteGoods.vue?vue&type=script&lang=js&"
import style0 from "./VoteGoods.vue?vue&type=style&index=0&id=08285824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08285824",
  null
  
)

export default component.exports